import { UniDriver } from '@wix/unidriver-core';
import {
  baseUniDriverFactory,
  findByHook,
} from '../../../utils/test-utils/unidriver';
import { dataHooks } from './constants';

export const sectionDriverFactory = (base: UniDriver) => {
  const titleElement = () => findByHook(base, dataHooks.pageSectionTitle);
  const subtitleElement = () => findByHook(base, dataHooks.pageSectionSubtitle);
  const actionsBarElement = () =>
    findByHook(base, dataHooks.pageSectionActionsBar);

  return {
    ...baseUniDriverFactory(base),
    /**
     * Gets PageSection title text
     * @return {Promise<string>}
     */
    getTitleText: (): Promise<string> => titleElement().text(),
    /**
     * Checks whether the PageSection title exists
     * @returns {Promise<boolean>}
     */
    isTitleExists: (): Promise<boolean> => titleElement().exists(),
    /**
     * Gets PageSection subtitle text
     * @return {Promise<string>}
     */
    getSubtitleText: (): Promise<string> => subtitleElement().text(),
    /**
     * Checks whether the PageSection subtitle exists
     * @returns {Promise<boolean>}
     */
    isSubtitleExists: (): Promise<boolean> => subtitleElement().exists(),
    /**
     * Checks whether the PageHeader action bar exists
     * @returns {Promise<boolean>}
     */
    isActionsBarExists: (): Promise<boolean> => actionsBarElement().exists(),
  };
};

export type SectionUniDriver = ReturnType<typeof sectionDriverFactory>;
